var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPoint = function SvgPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 90,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 31.772a4.675 4.675 0 0 1 3.306-5.725L97.996 1.21a4.674 4.674 0 0 1 5.726 3.306l5.671 21.164c-1.272 1.513-1.778 3.838-1.151 6.178s2.228 4.101 4.086 4.775l5.671 21.163a4.675 4.675 0 0 1-3.306 5.725l-92.69 24.837a4.675 4.675 0 0 1-5.726-3.306l-5.67-21.164c1.271-1.513 1.777-3.838 1.15-6.177-.627-2.34-2.227-4.1-4.085-4.775L2.001 31.772Z",
    fill: "url(#point_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m35.72 62.687 2.607-.699-5.33-19.892-6.73 1.803.612 2.285 4.123-1.105 4.717 17.608Zm15.222-3.6c4.172-1.118 6.401-5.415 4.538-12.369-1.863-6.953-5.942-9.56-10.114-8.442-4.197 1.124-6.426 5.421-4.563 12.375 1.863 6.954 5.942 9.56 10.14 8.436Zm-.619-2.31c-2.707.726-5.561-1.384-7.012-6.798-1.444-5.389-.033-8.668 2.674-9.393 2.682-.72 5.543 1.416 6.987 6.805 1.45 5.413.033 8.668-2.649 9.386Zm18.335-2.437c4.172-1.118 6.401-5.415 4.538-12.369-1.863-6.953-5.942-9.56-10.114-8.442-4.197 1.124-6.426 5.422-4.563 12.375 1.863 6.954 5.942 9.56 10.139 8.436Zm-.619-2.31c-2.707.726-5.561-1.384-7.012-6.798-1.444-5.389-.034-8.668 2.673-9.393 2.683-.72 5.544 1.416 6.988 6.805 1.45 5.413.033 8.668-2.649 9.387Zm12.823-3.88-.373-1.395 2.398-.643-.176-.657-1.09.292-.597-2.225 1.026-.275-.178-.665-5.39 1.445.178.664 1.026-.275.596 2.226-1.09.292.176.657 2.39-.64.374 1.394-2.709.726.18.672 6.163-1.652-.18-.672-2.724.73Zm-2.453-3.927 1.892-.507.597 2.225-1.893.507-.596-2.225Zm10.84 1.013.715-.191-1.227-4.58-.715.19 1.227 4.581Zm-3.277-.12c1.207-.324 1.748-1.282 1.47-2.315-.276-1.033-1.223-1.592-2.43-1.27-1.207.324-1.755 1.284-1.478 2.317.277 1.033 1.232 1.59 2.438 1.267Zm-.162-.608c-.737.198-1.365-.122-1.56-.851-.196-.73.186-1.328.923-1.525.73-.196 1.359.13 1.555.86.195.73-.189 1.32-.918 1.516Zm-.6 3.429 5.325-1.427-.174-.65-4.595 1.23-.366-1.365-.73.196.54 2.016Zm11.515-5.834L92 43.367l-.273-1.018 4.551-1.22-.168-.628-4.551 1.22-.271-1.012 4.63-1.241-.172-.643-5.346 1.432 1.057 3.945 5.44-1.458-.172-.642Zm-5.4 3.258.177.657 6.163-1.65-.177-.658-6.162 1.651Z",
    fill: "url(#point_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "point_svg__a",
    x1: -1.252,
    y1: 19.632,
    x2: 133.716,
    y2: 55.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "point_svg__b",
    x1: 81.687,
    y1: 46.647,
    x2: -27.677,
    y2: 37.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgPoint;